import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved, faBullhorn, faFileLines } from '@fortawesome/free-solid-svg-icons'

export default function CtaSection() {
  return (
    <section id="buat-laporan" className="py-24 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-blue-300/10 rounded-full blur-3xl" />
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <FontAwesomeIcon icon={faShieldHalved} className="w-16 h-16 text-blue-300 mx-auto mb-6" />
        <h2 className="text-3xl lg:text-4xl font-extrabold text-white leading-tight">
          Berani Melaporkan adalah Tindakan Patriotik
        </h2>
        <p className="mt-5 text-blue-100/80 text-lg max-w-2xl mx-auto leading-relaxed">
          Setiap laporan yang Anda sampaikan berkontribusi nyata dalam membangun Kalimantan Selatan yang lebih bersih, adil, dan berintegritas. Identitas Anda aman bersama kami.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/register"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white hover:bg-blue-50 text-blue-800 font-bold rounded-xl shadow-lg transition-all hover:scale-105">
            <FontAwesomeIcon icon={faBullhorn} className="w-5 h-5" />
            Buat Laporan Sekarang
          </a>
          <a href="/cek-laporan"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-blue-300/40 hover:border-blue-200 text-white font-semibold rounded-xl transition-all hover:bg-white/10">
            <FontAwesomeIcon icon={faFileLines} className="w-5 h-5" />
            Cek Status Laporan
          </a>
        </div>
      </div>
    </section>
  )
}
